const styles = (theme) => ({
  content: {
    padding: '20px 30px',
    height: '100%',
    width: '100%',
    backgroundColor: theme.palette.common.white,
    overflow: 'auto',
    [theme.breakpoints.down('md')]: {
      padding: '20px',
    },
  },
  gridContainer: {
    width: '100%',
  },
  gridWrapper: {
    height: 600,
    width: '100%',
    '& > div': {
      backgroundColor: theme.palette.common.white,
    },
  },
  errorText: {
    marginBottom: theme.spacing(1),
  },
  pageTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(0.5),
  },
  pageSubtitle: {
    marginBottom: theme.spacing(1),
  },
});

export default styles;
